<template>
  <O3D>
    <SwatWalk></SwatWalk>

    <!-- <FactoryPlace></FactoryPlace> -->

    <!--
    <O3D layout="diamonds">
      <WoozyDiamonds></WoozyDiamonds>
    </O3D> -->
    <!-- <O3D :pz="-20">
      <O3D :px="10">
        <GameNPC :char="'peter'" :dance="'Mma Idle'"></GameNPC>
      </O3D>

      <O3D :px="-10">
        <GameNPC :char="'alex'" :dance="'Mma Idle'"></GameNPC>
      </O3D>

      <O3D :px="-20">
        <GameNPC :char="'steve'" :dance="'Mma Idle'"></GameNPC>
      </O3D>

      <O3D :px="20">
        <GameNPC :char="'joe'" :dance="'Mma Idle'"></GameNPC>
      </O3D>

      <O3D :px="0">
        <GameNPC :char="'suzie'" :dance="'Mma Idle'"></GameNPC>
      </O3D>
    </O3D> -->

    <!--
    <O3D layout="loklok">
      <LokLokText></LokLokText>
    </O3D> -->

    <!--
    -->
    <!-- <O3D layout="jellyfish">
      <JellyFish></JellyFish>
    </O3D> -->

    <!-- <O3DSprite :visible="true" :py="12.5" :pz="-200" >
      <PortalScene :width="25" :height="25">
        <O3D :ry="pi">
          <Flower></Flower>
        </O3D>
      </PortalScene>
    </O3DSprite> -->

    <O3D :py="10" :pz="-25" :px="90 - 30 * 1">
      <TextClicker :sx="0.3" :sy="0.3" :py="2.5" @clicker="$root.$emit('play-move', { name: 'Gangnam Style' })" text="Gangnam Style"></TextClicker>
    </O3D>

    <O3D :py="10" :pz="-25" :px="90 - 30 * 2">
      <TextClicker :sx="0.3" :sy="0.3" :py="2.5" @clicker="$root.$emit('play-move', { name: 'Brooklyn Uprock' })" text="Brooklyn Uprock"></TextClicker>
    </O3D>

    <O3D :py="10" :pz="-25" :px="90 - 30 * 3">
      <TextClicker :sx="0.3" :sy="0.3" :py="2.5" @clicker="$root.$emit('play-move', { name: 'House Dancing' })" text="House Dancing"></TextClicker>
    </O3D>

    <O3D :py="10" :pz="-25" :px="90 - 30 * 4">
      <TextClicker :sx="0.3" :sy="0.3" :py="2.5" @clicker="$root.$emit('play-move', { name: 'a1-Victory' })" text="Victory"></TextClicker>
    </O3D>

    <O3D :py="10" :pz="-25" :px="90 - 30 * 5">
      <TextClicker :sx="0.3" :sy="0.3" :py="2.5" @clicker="$root.$emit('play-move', { name: 'a2-Defeat' })" text="Defeated"></TextClicker>
    </O3D>

    <O3D :py="15" :pz="-50" :px="90 - 30 * 1">
      <TextClicker :sx="0.3" :sy="0.3" :py="2.5" @clicker="$root.$emit('play-move', { name: 'Breakdance Freezes' })" text="Breakdance Freezes"></TextClicker>
    </O3D>

    <O3D :py="15" :pz="-50" :px="90 - 30 * 2">
      <TextClicker :sx="0.3" :sy="0.3" :py="2.5" @clicker="$root.$emit('play-move', { name: 'Breakdance Freeze Var 2' })" text="Breakdance Freeze Var 2"></TextClicker>
    </O3D>

    <O3D :py="15" :pz="-50" :px="90 - 30 * 3">
      <TextClicker :sx="0.3" :sy="0.3" :py="2.5" @clicker="$root.$emit('play-move', { name: 'Breakdance Uprock To Ground (1)' })" text="Breakdance Uprock To Ground (1)"></TextClicker>
    </O3D>

    <O3D :py="15" :pz="-50" :px="90 - 30 * 4">
      <TextClicker :sx="0.3" :sy="0.3" :py="2.5" @clicker="$root.$emit('play-move', { name: 'Flair (2)' })" text="Flair (2)"></TextClicker>
    </O3D>

    <O3D :py="15" :pz="-50" :px="90 - 30 * 5">
      <TextClicker :sx="0.3" :sy="0.3" :py="2.5" @clicker="$root.$emit('play-move', { name: 'Hip Hop Dancing (1)' })" text="Hip Hop Dancing (1)"></TextClicker>
    </O3D>


    <O3D layout="flower">
      <!-- flower -->

      <!-- <O3D :px="-5">
        <O2DHTML :py="0.3" class="z-10">
          <HappyApp />
        </O2DHTML>
      </O3D> -->

      <!-- <Flower></Flower> -->

      <!--
      <SpriteLabel :sx="0.05" :sy="0.05" :py="2.5" text="🌸🌸🌸🌸🌸🌸🌸🌸">
      </SpriteLabel>
      -->

      <SpriteLongText :py="1" :px="0" :text="sprite">
      </SpriteLongText>
    </O3D>

    <!--
    <O3D layout="glowball">
      <GlowBall></GlowBall>
    </O3D>
    -->

    <!-- <O3D layout="fruits">
      <FruitCollection></FruitCollection>
    </O3D> -->

    <!-- <O3D layout="woozyball">
      <WoozyBall></WoozyBall>
    </O3D> -->
  </O3D>
</template>

<script>
import { O3DG2 } from '../../Reusable/O3DG2'
// import { BoxBufferGeometry, MeshBasicMaterial, Mesh } from 'three'

export default {
  mixins: [O3DG2],
  data () {
    return {
      seeThis: {},
      sprite: `4 Love is patient and kind; love does not envy or boast; it is not arrogant 5 or rude. It does not insist on its own way; it is not irritable or resentful;[a] 6 it does not rejoice at wrongdoing, but rejoices with the truth. 7 Love bears all things, believes all things, hopes all things, endures all things. \n\n Corinthians 13:4-7`,
      layouts: []
    }
  },
  methods: {
    async setup () {
      let layouts = this.layouts
      this.onLoop(() => {
        layouts.loklok = {
          pz: -50,
          py: 5
        }
        layouts.diamonds = {
          pz: 0,
          py: 5
        }
        layouts.ball = {
          pz: -100
        }
        layouts.flower = {
          pz: -100,
          py: 15,
          sx: 10,
          sy: 10,
          sz: 10
        }
        layouts.jellyfish = {
          pz: -50
        }
        layouts.glowball = {
          pz: -200,
          py: 15
        }
        layouts.fruits = {
          pz: -250,
          py: 16
        }
        layouts.woozyball = {
          pz: -250,
          py: 6
        }
      })
    }
  },
  mounted () {
    this.setup()
  }
}
</script>

<style>

</style>